import { DetailedHTMLProps, SelectHTMLAttributes } from "react";
import { components } from "react-select";
import { Select } from "react-select-virtualized";

interface ISelectHookFormSingleVIP
  extends DetailedHTMLProps<
    SelectHTMLAttributes<HTMLSelectElement>,
    HTMLSelectElement
  > {
  field?: any;
  options: any;
  isDisabled?: boolean;
  className?: string;
  label?: string;
  validation?: any;
  onChange?: any;
  value?: any;
  isClearable?: boolean;
  defaultValue?: any;
  isLoading?: boolean;
  labelClassName?: string;
  secondDiv?: string;
  selectClass?: string;
  placeHolder?: string;
}
const SelectHookFormSingleVIP: React.FC<ISelectHookFormSingleVIP> = ({
  field,
  options,
  className,
  label,
  onChange, // send value to hook form
  value,
  defaultValue,
  isLoading,
  secondDiv = "grid  items-center space-y-2",
  isClearable = true,
  isDisabled = false,
  required = false,
  placeHolder,
}) => {
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      background: isDisabled ? "#FAFAFA" : "#ffffff",
      border: "0px",
      borderColor: "#edebeb",
      minHeight: "26px",
      height: "6px",
      boxShadow: state.isFocused ? null : null,
      fontSize: "10.4px",
    }),

    // Dropdown Placeholder
    option: (provided, state) => ({
      ...provided,
      active: "",
      //  padding: "3px",
      color: state.isSelected ? "white" : "black",
      fontSize: "10.4px",
    }),
    menu: (provided, state) => ({
      ...provided,
      //overflowX: "auto",
      //padding: "0px 6px",
      minHeight: "auto",
      maxHeight: "auto",
      zIndex: "10px",
      fontSize: "10px",
      whiteSpace: "nowrap",
      width: "300px",
      itemSize: 35,
    }),
    // placeholder: (provided, state) => ({
    //   ...provided,
    //   overflowX: "auto",
    //   marginLeft: "0px ",
    //   marginRight: "-3px",
    // }),

    // Selected Placeholder
    valueContainer: (provided, state) => ({
      ...provided,
      height: "26px",
      // padding: "0px 6px",
      fontSize: "10.4px",
    }),

    // Filter Placeholder
    input: (provided, state) => ({
      ...provided,
      // margin: "0px",
      fontSize: "10.4px",
    }),
    // indicatorSeparator: (state) => ({
    //   display: "none",
    // }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: "28px",
      margin: "0px",
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };

  return (
    <div className="space-y-1 w-full">
      <div className={`${secondDiv} w-full items-start`}>
        {label && (
          <label
            className={`flex items-stretch text-left expandedLabel fontExpand`}
          >
            {required && (
              <span className="text-red-500 font-bold self-start">*</span>
            )}{" "}
            {label}:{" "}
          </label>
        )}

        <Select
          {...field}
          className={`${
            className ? className : "border border-gray-300"
          } w-full rounded-sm text-xxs focus:ring-quaternary focus:border-quaternary${
            isDisabled && "opacity-50 "
          }`}
          components={components}
          menuPortalTarget={document.body}
          styles={customStyles}
          isLoading={isLoading}
          options={options}
          onChange={onChange}
          isSearchable
          isDisabled={isDisabled}
          isClearable={isClearable}
          defaultValue={defaultValue}
          value={
            value || value === false
              ? options?.find((c) => c.value === value)
              : null
          }
          isMulti={false}
          tabSelectsValue={false}
          // placeholder={
          //   !options.find((c) => c.value === value) && value
          //     ? value
          //    : placeHolder
          // }
          placeholder={placeHolder}
        />
      </div>
    </div>
  );
};

export default SelectHookFormSingleVIP;
